import { render, staticRenderFns } from "./one-home.vue?vue&type=template&id=af1fbd2c"
import script from "./one-home.vue?vue&type=script&lang=js"
export * from "./one-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports